export default function HealthCheck() {
    return(
        <h3>App is Healthy</h3>
    )
}